import PropTypes from 'prop-types';
import { useRef } from '@web-stories-wp/react';
import { useUnits } from '@web-stories-wp/units';
import { useTransformHandler } from '../../components/transform';
import { getElementBackdropStyles } from './getElementBackdropStyles';

export default function ElementBackdrop({
  element,
  style,
  backdropRef,
  applyFlip = true,
  includeBorder = true,
}) {
  const localRef = useRef(null);
  const ref = backdropRef || localRef;
  const { dataToEditorX, dataToEditorY } = useUnits((state) => state.actions);
  useTransformHandler(element.id, (transform) => {
    if (!ref.current || (transform && !transform.resize)) return;
    const resize = transform?.resize;
    if (resize && (resize[0] <= 0 || resize[1] <= 0)) return;
    const currentElement = resize
      ? {
          ...element,
          width: resize[0] / dataToEditorX(1),
          height: resize[1] / dataToEditorY(1),
        }
      : element;
    const currentStyle = getElementBackdropStyles({
      element: currentElement,
      applyFlip,
      includeBorder,
      offsetForBorderFlip: applyFlip,
      dataToStyleX: (value) => `${dataToEditorX(value)}px`,
      dataToStyleY: (value) => `${dataToEditorY(value)}px`,
    });
    Object.assign(ref.current.style, { ...style, ...currentStyle });
  });
  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="element-backdrop"
      style={style}
    />
  );
}
ElementBackdrop.propTypes = {
  backdropRef: PropTypes.object,
  applyFlip: PropTypes.bool,
  includeBorder: PropTypes.bool,
  element: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired,
};
